
import React from 'react';

const WorkshopPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 md:px-6 py-20">
      <div className="max-w-4xl mx-auto space-y-12 text-center">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-stone-900">Atölyemiz</h1>
        <p className="text-lg text-stone-500 max-w-2xl mx-auto">Üretim aşamasının her anı şeffaf ve sevgi dolu. İşte Lumina Home'un kalbi.</p>
        <div className="grid md:grid-cols-2 gap-8">
           <div className="aspect-square rounded-[2rem] bg-stone-100 overflow-hidden">
             <img src="https://images.unsplash.com/photo-1459749411177-042180ce673c?auto=format&fit=crop&q=80&w=600" className="w-full h-full object-cover" />
           </div>
           <div className="aspect-square rounded-[2rem] bg-stone-100 overflow-hidden">
             <img src="https://images.unsplash.com/photo-1590487988256-9ed24133863e?auto=format&fit=crop&q=80&w=600" className="w-full h-full object-cover" />
           </div>
        </div>
        <div className="prose prose-stone mx-auto text-stone-600 space-y-6">
          <p>Atölyemizde sadece doğal soya ve balmumu kullanıyoruz. Kimyasal esanslar yerine doğal yağlar tercih ederek evinizin havasını temiz tutuyoruz.</p>
          <p>Her biblo ve dekoratif obje, özel kalıplarımızda döküldükten sonra el ile zımparalanır ve doğal koruyucularla son haline getirilir.</p>
        </div>
      </div>
    </div>
  );
};

export default WorkshopPage;
